<template>
    <div>
        <rkm-form ref="Form">
            <rkm-tabs v-model="tabIndex">
                <rkm-tab
                    title="JORNADAS CADASTRADAS"
                    @click.prevent="setActive('JornadasCadastradas')"
                >
                    <tab-jornadas-cadastradas
                        v-if="unidadeId"
                        ref="TabJornadasCadastradas"
                        :form="form"
                        :model="model"
                        :id="id"
                        :unidadeId="unidadeId"
                        :infraestruturaId="infraestruturaId"
                        @handleAlter="handleAlter"
                        @loadDays="loadDays"
                    />
                </rkm-tab>

                <rkm-tab
                    title="CADASTRAR JORNADA"
                    @click.prevent="setActive('InclusaoJornada')"
                >
                    <tab-inclusao-jornada
                        ref="TabInclusaoJornada"
                        :form="form"
                        :model="model"
                        :id="id"
                        :unidadeId="unidadeId"
                        :infraestruturaId="infraestruturaId"
                        :jornada="jornada"
                        :index="index"
                        :diasCalendario="diasCalendario"
                        @backTabs="backTabs"
                        @backTabsNotification="backTabsNotification"
                        @loadDiasCalendario="loadDiasCalendario"
                        @handleAlter="handleAlter"
                        @search="search"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

//Moment
import moment from 'moment'

// Enuns.
import modulo from '@/enums/cadastro/feriado/modulo'

// Mixins.
import { formats, repository, stringCase, object, error } from '@/mixins'

// Components.
import TabJornadasCadastradas from '@/components/exame-laboratorial/jornada/components/Index'
import TabInclusaoJornada from '@/components/exame-laboratorial/jornada/components/cadastro/Form'

export default {
    components: {
        TabJornadasCadastradas,
        TabInclusaoJornada,
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameLaboratorial.jornada'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')
        },
        this.load()
    },
    data: () => ({
        model: {
            cadastro: [],
            inclusao: [],
        },
        form: {},
        tabIndex: 0,
        index: null,
        unidadeId: null,
        infraestruturaId: null,
        jornada: {
            data: null,
            diasSemana: null,
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            jornadaId: '',
            semanaId: null,
            selecionado: false,
            tempoAtendimento: '',
            tipoId: null,
            tipoNome: null,
            unidadeId: null,
            vagas: '',
            vagasApp: '',
            laboratorioPrestadorInfraestruturaId: null,
            periodo: {
                start: null,
                end: null,
            },
        },
        diasCalendario: [],
        enums: {
            modulo
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.jornada.show(this.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.unidadeId = data.model.unidadeId
                    this.infraestruturaId = data.model.infraestruturaId

                    this.$nextTick().then(() => {

                        this.tabRefs = [
                            this.$refs.TabJornadasCadastradas,
                            this.$refs.TabInclusaoJornada,
                        ]
                    })

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setJornada(){
            this.jornada = {
                data: null,
                diasSemana: [],
                horaInicial: '',
                horaFim: '',
                infraestruturaId: null,
                jornadaId: '',
                semanaId: null,
                selecionado: false,
                tempoAtendimento: '',
                tipoId: null,
                tipoNome: null,
                unidadeId: null,
                vagas: '',
                vagasApp: '',
                laboratorioPrestadorInfraestruturaId: null,
                periodo: {
                    start: null,
                    end: null,
                },
            }
        },
        setActive(){

            this.setJornada()
            this.index = null
        },
        save() {

            this.setLoading()

            this.repositories.jornada.store(this.prepareData())
                .then(() => {
                    this.showSaveNotification()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            if(this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0){

                this.model.jornadasNotSave.map(jornada => {

                    this.unidadeId = jornada.unidadeId,
                    this.infraestruturaId = jornada.infraestruturaId

                    const request = {

                        unidadeId: jornada.unidadeId,
                        infraestruturaId: jornada.infraestruturaId,
                        semanaId: jornada.semanaId,
                        diassemana: jornada.diasSemana,
                        tipoId: jornada.tipoId,
                        data: jornada.data,
                        horaInicial: jornada.horaInicial,
                        horaFim: jornada.horaFim,
                        vagas: jornada.vagas,
                        vagasApp: jornada.vagasApp,
                        laboratorioPrestadorInfraestruturaId: jornada.laboratorioPrestadorInfraestruturaId,
                        tempoAtendimento: jornada.tempoAtendimento,
                        jornadaId: jornada.jornadaId,
                        tipoNome: jornada.tipoNome,
                        diasSemana: jornada.diasSemana,
                        agendamentos: jornada.agendamentos,
                        vagasDisponiveis: jornada.vagasDisponiveis,
                        laboratorioPrestadorNome: jornada.laboratorioPrestadorNome,
                        selecionado: jornada.selecionado,
                        periodo: jornada.periodo,
                        primeiroHorario: jornada.primeiroHorario,
                        ultimoHorario: jornada.ultimoHorario,
                    }

                    let jornadasNotSave = this.model.jornadas.findIndex(j => j.jornadaId == jornada.jornadaId)

                    this.model.jornadas[jornadasNotSave] = request
                })
            } else {

                this.model.jornadas.map(jornada => {

                    this.unidadeId = jornada.unidadeId,
                    this.infraestruturaId = jornada.infraestruturaId

                    return {

                        unidadeId: jornada.unidadeId,
                        infraestruturaId: jornada.infraestruturaId,
                        semanaId: jornada.semanaId,
                        diassemana: jornada.diasSemana,
                        tipoId: jornada.tipoId,
                        data: jornada.data,
                        horaInicial: jornada.horaInicial,
                        horaFim: jornada.horaFim,
                        vagas: jornada.vagas,
                        tempoAtendimento: jornada.tempoAtendimento,
                    }
                })
            }
            return this.camelObjectKeysToSnakeRecursive(

                this.model
            )
        },
        handleAlter(item, index) {

            this.index = index
            this.jornada = this.clone(item)

            this.jornada.periodo.start = moment(item.periodo.start, 'DD/MM/YYYY').toDate()
            this.jornada.periodo.end = moment(item.periodo.end, 'DD/MM/YYYY').toDate()

            this.tabIndex = 1
        },
        backTabs(){

            if( this.index != null){

                this.tabIndex = 0
            }

            this.setJornada()
        },
        backTabsNotification(){

            if( this.index != null){

                this.showSaveNotification('Registro da jornada selecionada alterada com sucesso.')

            } else {

                this.showSaveNotification('Registro da jornada adicionada.')
            }
        },
        validate() {

            return this.tabRefs[this.tabIndex].validate()
        },
        loadDays(value) {

            this.model.jornadas = value

            let diasCalendario = []

            value.map(unidade => diasCalendario.push({
                'dates': moment(unidade.data, 'DD/MM/YYYY').toDate(),
                'title': 'icon-search',
                'highlight': 'green'
            }))

            this.form.feriados.map(feriado =>

                feriado.modulos.map(modulo => {

                    if(modulo == this.enums.modulo.EXAME_LABORATORIAL){

                        diasCalendario.push({
                            'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                            'highlight': 'yellow',
                            'title': feriado.tipoNome,
                            'popover':  feriado.observacao
                        })
                    }
                })
            )

            this.loadDiasCalendario(diasCalendario)
        },
        loadDiasCalendario(value) {

            this.diasCalendario = value
        },
        search() {

            if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                this.$refs.TabJornadasCadastradas.search()
            }
        }
    },
    mixins: [formats, repository, stringCase, object, error],
    props: {
        id: { type: Number }
    },
}
</script>

<style>
.tabs {
    border: 0px solid #dee2e6!important;
    border-radius: 0.25rem;
}
</style>